import { CURRENCY, ACCOUNTING } from '../common/constants';

export default function isCurrencyStyle(style) {
    return style === CURRENCY || style === ACCOUNTING;
}
//# sourceMappingURL=is-currency-style.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-intl/dist/es/numbers/is-currency-style.js
// module id = ../../../../@telerik/kendo-intl/dist/es/numbers/is-currency-style.js
// module chunks = 3